import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { addParametersToUri } from 'nallian-shared-ui/lib/lib/uri';
import HasRight from 'nallian-shared-ui/lib/layout/rights/HasRight';
import { Link, Button } from 'nallian-shared-ui/lib/components';
import { Table, Actions, Params, Menu } from 'nallian-table-builder-ui';
import {
  INFINITE_SCROLL,
  COMMUNITY_APPS_RESOURCE,
  ACTIONS,
  COMMUNITY_TAB_ACTIONS,
  COMMUNITY_DETAIL_TABS,
} from '../../constants';
import NewCommunityApp from './NewCommunityApp';
import apiRoutes from '../../../../app/api/routes';
import CommunityAppFeatures from './CommunityAppFeatures';

const COMMUNITY_APPS_VIEW_RIGHTS = ['COMMUNITYAPPS.MANAGE.ALL', 'COMMUNITYAPPS.READ.ALL'];

const CommunityAppsOverview = () => {
  const { t } = useTranslation();
  const { id, action, actionId } = useParams();

  return (
    <>
      <HasRight right="COMMUNITYAPPS.MANAGE.ALL">
        <NewCommunityApp open={id && action && !actionId} />
        {action !== COMMUNITY_TAB_ACTIONS.VIEW_APP && action !== COMMUNITY_TAB_ACTIONS.EDIT_APP && (
          <Link
            to={`/communities/edit/${id}/${COMMUNITY_DETAIL_TABS.APPS}/${COMMUNITY_TAB_ACTIONS.NEW_APP}`}
          >
            <Button btnprimary icon="plus" content={t('addApp')} />
          </Link>
        )}
      </HasRight>
      {(action === COMMUNITY_TAB_ACTIONS.VIEW_APP || action === COMMUNITY_TAB_ACTIONS.EDIT_APP) &&
      actionId ? (
        <CommunityAppFeatures />
      ) : (
        <Table
          url={addParametersToUri(apiRoutes.communityApps(), { communityId: id })}
          infiniteScroll={INFINITE_SCROLL}
          resource={COMMUNITY_APPS_RESOURCE}
          pageSize={50}
          noUserSettings
          resizable
          filtered
          sorted
        >
          <Actions.Link
            width="2.5rem"
            align="center"
            icon="eye"
            hasSomeRights={COMMUNITY_APPS_VIEW_RIGHTS}
            url={`/communities/${ACTIONS.EDIT}/${id}/${COMMUNITY_DETAIL_TABS.APPS}/${COMMUNITY_TAB_ACTIONS.VIEW_APP}/:id`}
          />
          <Params.String
            name="appInstallation.name"
            label="name"
            width="16rem"
            minWidth="16rem"
            grow
            noFilter
          />
          <Params.String
            name="appInstallation.tag"
            label="tag"
            width="16rem"
            minWidth="16rem"
            grow
            noFilter
          />
          <Menu width="3.5rem" align="center" hasRight="COMMUNITYAPPS.MANAGE.ALL">
            <Actions.Link
              label="edit"
              icon="edit"
              url={`/communities/${ACTIONS.EDIT}/${id}/${COMMUNITY_DETAIL_TABS.APPS}/${COMMUNITY_TAB_ACTIONS.EDIT_APP}/:id`}
            />
            <Actions.Delete url={apiRoutes.communityApps(':id')} />
          </Menu>
        </Table>
      )}
    </>
  );
};

export default CommunityAppsOverview;
